import { Component, OnInit, Inject } from '@angular/core';
import { Data } from '../../models/data';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../../services/api/api.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../services/auth/auth.service';


export interface DialogData {
  animal: string;
  name: string;
}

export interface DialogData2 {
  animal: string;
  name: string;
}

export interface DialogData3 {
  animal: string;
  name: string;
}

export interface DialogData4 {
  animal: string;
  name: string;
}



@Component({
  selector: 'app-password',
  templateUrl: './password.page.html',
  styleUrls: ['./password.page.scss'],
})
export class PasswordPage implements OnInit {

  panelOpenState = false;
  
  open(menu)
  {
    menu.openMenu();
  }

  data = new Data();
  companyg:any;
  name: any;
  address: any;
  phone: any;
  email: any;
  current_year: number = new Date().getFullYear();
  credential = {npassword: null, vpassword: null, user: null};

  //fz
  hide: any;
  error: any;
  is_verify_password: any;
  is_new_password: any;


  constructor(private apiService: ApiService, private authService: AuthService, public dialog: MatDialog, private spinner: NgxSpinnerService) { 
    this.credential.npassword = "";
    this.credential.vpassword = "";
    this.credential.user = localStorage.getItem('user');
  }

  ngOnInit() {
    this.companyg = localStorage.getItem('companyg');
    this.name = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    this.address = localStorage.getItem('address');
    this.phone = localStorage.getItem('phone');
    this.email = localStorage.getItem('email');
  }

  //new function fairuz
  redirect() {
    window.location.href = 'http://dexpay.dexasia.com.my';
  }
  
  change() {
    this.spinner.show();
    this.apiService.postData(this.data).subscribe((response) => {
      console.log(response);

      if ( (this.credential.npassword != "" && this.credential.vpassword != "") && (this.credential.npassword == this.credential.vpassword) )
      {
        if (this.credential.npassword.length >=6 && this.credential.vpassword.length >=6) 
        {
          this.data =  {
            id: 2,
            name: 'changePasswordNew',
            content: {
              id : this.credential.user,
              mac: this.credential.npassword
            }
          };
      
          this.spinner.show();
          this.apiService.postData(this.data).subscribe((response) => {
            console.log(response);
            this.spinner.hide();
            this.openDialog();
            console.log('message popup pwd changed successfully!');
            this.redirect();
          });
        }
        else{
          this.spinner.hide();
          this.openDialog4()
          console.log('error popup n & v p must be at least 6 characters!');
        }
      }  
      else if ( (this.credential.npassword != "" && this.credential.vpassword != "") && (this.credential.npassword != this.credential.vpassword) )
      {
        this.spinner.hide();
        this.openDialog2()
        console.log('error popup n & v p must be matched!');
      }  
      else{
        this.spinner.hide();
        this.openDialog3()
        console.log('error popup both n & v pwd is null!');
      }

    });
  }

  getMaxLimit() {
    if (this.credential.npassword) {
      return 12;
    }
    else {
      return null;
    }
  }

  getMaxLimit2() {
    if (this.credential.vpassword) {
      return 12;
    }
    else {
      return null;
    }
  }

  getInputLabel() {
    if (this.credential.npassword.length < 6 ) {
      return "It must be at least 6 characters!";
    }
    else {
        return null;
    }
  }

  getInputLabel2() {
    if (this.credential.vpassword.length < 6) {
      return "It must be at least 6 characters!";
    }
    else {
        return null;
    }
  }

  //end


  logout() {
    this.authService.logout();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogEightPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  openDialog2(): void {
    const dialogRef = this.dialog.open(DialogChangePasswordPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  openDialog3(): void {
    const dialogRef = this.dialog.open(DialogNullNewandVerifyPasswordPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  openDialog4(): void {
    const dialogRef = this.dialog.open(DialogNullNewandVerifyPasswordCharactersLimitPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogEightPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}


@Component({
  selector: 'mydialog2',
  templateUrl: 'dialog2.html',
})

export class DialogChangePasswordPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData2) {}

}


@Component({
  selector: 'mydialog3',
  templateUrl: 'dialog3.html',
})

export class DialogNullNewandVerifyPasswordPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData3) {}

}

@Component({
  selector: 'mydialog4',
  templateUrl: 'dialog4.html',
})

export class DialogNullNewandVerifyPasswordCharactersLimitPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData4) {}

}


